<template>
  <div class="sans absolute" :style="style">
    <vue-slider @callback="cb" ref="slider" v-model="value" :show="show" v-bind="options"></vue-slider>
  </div>
</template>

<script>
import vueSlider from 'vue-slider-component'
export default {
  name: 'map-slider',
  props: ['maps'],
  components: {
    vueSlider
  },

  data () {
    return {
      value: this.value,
      show: false
    }
  },

  watch: {
    currentUri (val) {
      this.reinitSlider()
    }
  },

  mounted () {
    this.reinitSlider()
  },

  activated () {
    this.reinitSlider()
  },

  computed: {

    style () {
      if (this.location === 'south') {
        return 'top: 560px; left: 137px;'
      }
      return 'top: 560px; right: 161px;'
    },

    location () {
      return this.$store.getters['settings/location']
    },

    currentUri () {
      return this.$route.path
    },

    firstLabel () {
      return this.maps[this.maps.length - 1].label
    },

    labels () {
      let labels = []

      this.maps.forEach((item) => {
        labels.push(item.label)
      })
      return labels
    },
    options () {
      let style = { 'color': 'white', 'fontSize': '1.25rem', 'marginLeft': '24px' }
      if (this.location === 'south') {
        style = { 'color': 'white', 'fontSize': '1.25rem', 'marginLeft': '24px', 'position': 'absolute', 'left': '-190px', 'width': '130px', 'text-align': 'right' }
      }

      return {
        eventType: 'auto',
        direction: 'vertical',
        width: 16,
        height: 300,
        dotSize: 32,
        dotHeight: null,
        dotWidth: null,
        data: this.labels,
        show: true,
        speed: 0.5,
        disabled: false,
        piecewise: true,
        piecewiseStyle: null,
        piecewiseLabel: true,
        tooltip: true,
        tooltipDir: 'top',
        reverse: false,
        clickable: true,
        realTime: false,
        lazy: false,
        formatter: null,
        bgStyle: null,
        sliderStyle: null,
        processStyle: null,
        piecewiseActiveStyle: null,
        tooltipStyle: null,
        labelStyle: style,
        labelActiveStyle: null,
        callbackVal: ''
      }
    }
  },
  methods: {
    cb (val) {
      this.$emit('map-slider-changed', val)
    },

    reinitSlider () {
      this.$nextTick(() => {
        this.value = this.firstLabel
        this.show = true
        this.$refs.slider.refresh()
      })
    }
  }
}
</script>

